import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import PostList from "./PostList";
import Socials from "./Socials";

const MenuIcon = ({ open }: { open: boolean }) => (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        {open
            ? <path d="M6 6l12 12M18 6L6 18" />
            : <path d="M4 7h16M4 12h16M4 17h16" />}
    </svg>
);

const MobileMenu = () => {
    const { posts } = useContext(AppContext);
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    // The post list starts expanded when you're already reading a post.
    const [postsExpanded, setPostsExpanded] = useState(pathname.startsWith("/posts/"));

    // Close after navigating.
    useEffect(() => setOpen(false), [pathname]);

    // Stop the page behind the menu from scrolling, and close on Escape.
    useEffect(() => {
        if (!open) return;
        document.body.style.overflow = 'hidden';
        const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', onKey);
        };
    }, [open]);

    return <div className="md:hidden">
        <button onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open}
            className="text-accent p-1 -mr-1 transition-colors duration-700">
            <MenuIcon open={false} />
        </button>

        <div onClick={() => setOpen(false)}
            className={`fixed inset-0 z-40 bg-black/60 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} />

        <nav aria-label="Menu"
            className={`fixed inset-y-0 right-0 z-50 w-72 max-w-[85vw] flex flex-col bg-base border-l-2 border-accent px-6 pt-6 pb-8 shadow-2xl transition-[transform,visibility] duration-300 ${open ? 'translate-x-0 visible' : 'translate-x-full invisible'}`}>
            <button onClick={() => setOpen(false)} aria-label="Close menu" className="self-end text-accent p-1 -mr-1">
                <MenuIcon open={true} />
            </button>
            <div className="mt-6 flex-1 overflow-y-auto no-scrollbar">
                <button onClick={() => setPostsExpanded(!postsExpanded)} aria-expanded={postsExpanded}
                    className="flex w-full items-center justify-between text-2xl font-semibold text-white">
                    posts
                    <svg viewBox="0 0 24 24" className={`w-5 h-5 text-accent transition-transform ${postsExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                        <path d="M6 9l6 6 6-6" />
                    </svg>
                </button>
                {postsExpanded && <PostList posts={posts} className="mt-5 pl-4 border-l border-white/10" />}
            </div>
            <Socials className="pt-6 border-t border-white/10 text-sm text-slate-400" />
        </nav>
    </div>;
};

export default MobileMenu;
